import "./PollySearchNoResultsComponent.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";

import NoResultsImage from "../../_shared/assets/empty-cactus.svg";

export const PollySearchNoResultsComponent: React.FC = () => {
  return (
    <div className="no-results-container">
      <Flex column className="no-results" hAlign="center" vAlign="center" gap="gap.small" fill>
        <img src={NoResultsImage} height={100} alt="No results" />
        <Text content="No results found." className="no-results__heading" />
        <Text
          content="We couldn’t find any results based on your search. Please try searching again using different words."
          className="no-results__sub-heading"
        />
      </Flex>
    </div>
  );
};
